module.exports = __webpack_public_path__ + "img/edit_disable.2a494e26.svg";